module.exports = __webpack_public_path__ + "static/1_1_defineai_PL-7ed716f52ae817dc3cd1fc82cce4cce8.svg";